import { render, staticRenderFns } from "./formInfo.vue?vue&type=template&id=12d33b91&"
import script from "./formInfo.vue?vue&type=script&lang=js&"
export * from "./formInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d33b91')) {
      api.createRecord('12d33b91', component.options)
    } else {
      api.reload('12d33b91', component.options)
    }
    module.hot.accept("./formInfo.vue?vue&type=template&id=12d33b91&", function () {
      api.rerender('12d33b91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/manage/components/formInfo.vue"
export default component.exports